import AddClusterForm from "../../components/Forms/AddclusterForm";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";






function AddCluster() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
             <AddClusterForm/>
            </BasicCard>
        </>
    )
}
export default AddCluster;